const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,
  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  YIAPI = `//yiapi${spell}.xinli001.com/v5/yi/`,
  HCP = `//hcp${spell}.xinli001.com/`,
  APIS = {
    // 生涯卡模块接口 
    lifeCardCardList: `${HCP}lifeCard/cardList`, //获取生涯卡列表
    lifeCardCommitAnswer: `${HCP}lifeCard/commitAnswer`, //生涯卡-提交答案
    lifeCardViewReport: `${HCP}lifeCard/viewReport`, //生涯卡-获取报告
    getTeacher: `${HCP}lifeCard/getTeacher`, //生涯卡-获取咨询老师
  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/careerCard.js